export const openedModalZindexList: Array<number> = [];

let scrollLockCount = 0;
let savedBodyOverflow = "";
let savedBodyWidth = "";

export function acquireModalScrollLock(): void {
  if (scrollLockCount === 0) {
    savedBodyOverflow = document.body.style.overflow;
    savedBodyWidth = document.body.style.width;

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    // Lock background scroll with overflow:hidden only (not position:fixed on body).
    // Fixed body breaks teleported popups (e.g. vue-datepicker in modals) because window.scrollY
    // collapses to 0 and body becomes the containing block, shifting the menu up by scrollY.
    document.body.style.overflow = "hidden";
    document.body.style.width = scrollbarWidth > 0 ? `calc(100% - ${scrollbarWidth}px)` : "100%";
  }
  scrollLockCount++;
}

export function releaseModalScrollLock(): void {
  if (scrollLockCount === 0) {
    return;
  }

  scrollLockCount = Math.max(0, scrollLockCount - 1);
  if (scrollLockCount === 0) {
    document.body.style.overflow = savedBodyOverflow;
    document.body.style.width = savedBodyWidth;
  }
}
